import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { fetchRecognizedSendersByDomain } from '../common/actions/recognized-senders-action-creators';
import { fetchDomainNotes } from '../common/actions/domain-notes-action-creators';

import { domainsDetailsPaneSelector } from './selectors/domain-details-selectors';
import { domainNotesSelector } from '../common/selectors/domain-notes-selectors';
import { sendersDataByDomain } from '../sender-details/selectors/sender-details-selectors';

import DomainDetailsTabGeneral from './domain-details-tab-general';
import DomainDetailsTabDns from './domain-details-tab-dns';
import DomainDetailsSendersTabContainer from './domain-details-senders-tab-container';

export class DomainDetailsContentContainer extends Component{
    componentDidMount(){
        const { domainData } = this.props;
        this.fetchData( domainData.domainName );
    }

    componentDidUpdate( prevProps ){
        const {
            domainData: {
                domainDetails: {
                    domainName
                } = {}
            } = {}
        } = this.props;

        if( get( prevProps, 'domainData.domainDetails.domainName' ) !== domainName ){
            this.fetchData(  domainName );
        }
    }

    fetchData( domainName ){
        const { fetchDomainNotes, fetchRecognizedSendersByDomain } = this.props;

        fetchRecognizedSendersByDomain( domainName );
        fetchDomainNotes( domainName );
    }

    render(){
        const { domainData, domainNotesData, sendersData, tabIndex } = this.props;

        const tabContent = [
            <DomainDetailsSendersTabContainer
                domainName={domainData.domainName}
                sendersData={sendersData}
            />,
            <DomainDetailsTabDns dnsData={domainData.domainDetails} />,
            <DomainDetailsTabGeneral
                domainData={domainData}
                domainNotesData={domainNotesData}
            />,
        ];

        return tabContent[tabIndex];
    }
};

/* istanbul ignore next */
const mapStateToProps = ( state ) => ( {
    domainData: domainsDetailsPaneSelector( state ),
    domainNotesData: domainNotesSelector( state ),
    sendersData: sendersDataByDomain( state ),
} );

const mapStateToDispatch = {
    fetchDomainNotes,
    fetchRecognizedSendersByDomain
};

DomainDetailsContentContainer.propTypes = {
    domainData: PropTypes.shape( {
        actionsCount: PropTypes.number,
        authorizedMailVolume: PropTypes.number,
        dkimAlignRate: PropTypes.string,
        dkimPassAlignRate: PropTypes.string,
        dkimPassRate: PropTypes.string,
        dmarcDoublePassRate: PropTypes.string,
        dmarcPassRate: PropTypes.string,
        dmarcPolicy: PropTypes.string,
        domainCount: PropTypes.number,
        domainName: PropTypes.string.isRequired,
        domainType: PropTypes.string,
        orgDomain: PropTypes.string,
        percentBlocked: PropTypes.string,
        spfAlignRate: PropTypes.string,
        spfPassAlignRate: PropTypes.string,
        spfPassRate: PropTypes.string,
    } ),
    domainNotesData: PropTypes.array,
    fetchDomainNotes: PropTypes.func.isRequired,
    fetchRecognizedSendersByDomain: PropTypes.func.isRequired,
    sendersData: PropTypes.arrayOf( PropTypes.object ),
    tabIndex: PropTypes.number.isRequired
};

export default connect( mapStateToProps, mapStateToDispatch )( DomainDetailsContentContainer );
